import React from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { rtdb, db } from '../../config/firebase'
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import { Context } from '../../App';

import MediaUploads from './mediaUploads'
import UsersLIst from './UsersList'
import ChatSection from './ChatSection';
import Spinner from '../../components/Loading/TailSpin';
import ReactGA from "react-ga4";



function Interaction() {
  const navigate = useNavigate();
  const location = useLocation();
  const { enAutoRefContext,
    chatsContext,
    groupsContext,
    groupNameContext, groupIdContext} = useContext(Context);


  const [isLoading, setIsLoading] = useState(true);
  const [uid, setUid] = useState("");
  const [displayName, setDisplayName] = useState("");

  const [chats, setChats] = chatsContext;
  const [groups, setGroups] = groupsContext;
  const [groupName, setGroupName] = groupNameContext;
  const [groupId, setGroupId] = groupIdContext;
  const [allowedGroups, setAllowedGroups] = useState([]);



  const getChats = async (groupId, groupName) => {
    setGroupName(groupName);

    ReactGA.event({
      category: "Group",
      action: "Clicked",
      label: localStorage.getItem("displayName"),
      // value: groupId,
    });
  }

  useEffect(() => {


    const canUserJoinGrp = async () => {
      setIsLoading(true);
      try {
        const docRef = doc(db, "users", localStorage.getItem("uid"));
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          // console.log(userData.groups);
          setGroups(userData.groups);
          localStorage.setItem("displayName", userData.displayName)

          let isPartOf = false;
          let allGrp = [];
          userData.groups.forEach((group) => {
            allGrp.push(group.groupId);
            // console.log(group.groupId);
            if (group.groupId === groupId) {
              setGroupName(group.name);
              isPartOf = true;
            }
          })
          // setAllowedGroups(allGrp);

          if (isPartOf) {
            // getChats();
          }
          else {
            // navigate("/G");
          }

          // console.log("Document data:", docSnap.data());
        } else {
          // console.log("User DNE!");
          navigate('/signin')
        }

      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    };

    if (localStorage.getItem("uid")) {
      setUid(localStorage.getItem("uid"))
      setDisplayName(localStorage.getItem("displayName"))
      canUserJoinGrp();
    }
    else {
      navigate("/signin")
    }


    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Chatting" })

    ReactGA.event({
      category: "Group",
      action: "Accessed Group",
      label: localStorage.getItem("displayName"),
      // value: groupId,
    });
  }, []);



  if (!isLoading)
    return (
      <div className='relative w-full h-full flex justify-between'>
        <UsersLIst groupsData={[groups, setGroups]} getChats={getChats} />

        {groupName !== "" && <div className="absolute left-0 right-0 top-0 mx-auto w-fit border px-5 md:px-7 pt-1 md:pt-2 pb-1 md:pb-1.5 bg-white text-lg md:text-xl font-semibold text-headPrimary rounded-b-xl shadow-md border-l border-b border-r z-20 ">
          {groupName}
        </div>}

        <div className="w-full bg-[#fcfafdbf]">
          <ChatSection key={groupId} chats={chats} setChats={setChats} groupName={groupName} />
        </div>
        <MediaUploads />

      </div>
    )

  else return (<Spinner />)
}

export default Interaction